import { Page } from "components/layout/Page";
import { WidgetFrame } from "components/layout/WidgetFrame";
import { WidgetWithQueryParameters } from "components/layout/WidgetFrame/widget.types";
import { colSpan, height } from "components/widgets/widget.utils";
import { VectorLoadingAccuracyWidget } from "pages/DashboardPage/fms/widgets/VectorLoadingAccuracyWidget";
import { VectorSystemFailuresWidget } from "pages/DashboardPage/fms/widgets/VectorSystemFailuresWidget";

type Props = WidgetWithQueryParameters<"dateTo" | "dateFrom">;

const FeedingSection = (props: Props) => {
    return (
        <Page.Content.Section>
            <Page.Content.Section.Title>Feeding</Page.Content.Section.Title>
            <Page.Content.Widgets>
                <WidgetFrame colSpan={colSpan.chartHalf} height={height.chartSm}>
                    <VectorSystemFailuresWidget queryParameters={props.queryParameters} />
                </WidgetFrame>
                <WidgetFrame colSpan={colSpan.chartHalf} height={height.chartSm}>
                    <VectorLoadingAccuracyWidget queryParameters={props.queryParameters} />
                </WidgetFrame>
            </Page.Content.Widgets>
        </Page.Content.Section>
    );
};

export { FeedingSection };
